 
/**
 * Cấu hình nơi lưu trữ Cache
 * CacheMemory: Cache trên memory
 * CacheLocalStorage: Cache trên localStorage
 * CacheIndexDB: Cache trên IndexDB
 */
export const enumCacheLevel = {
	CacheMemory: 1,
	CacheLocalStorage: 2,
	CacheIndexDB: 3,
}
